export const VALID_RANKS = ['E5', 'E6'];
export const FIXED_DUTY_STATE = 'Regular';

/**
 * Cycle types mapping for Regular duty state
 * E5 and E6 both use type 'A'
 */
export const CYCLE_TYPES = {
  Regular: {
    E5: 'A',
    E6: 'B',
  },
};

/**
 * Get the digit that replaces the 'X' placeholder in an AFSC shortname based on rank.
 * E5 exams replace 'X' with '5', E6 exams replace 'X' with '7'.
 * @param {string} rank - E5 or E6
 * @returns {string} - '5' for E5, '7' for E6
 */
export const getRatingExamNumber = (rank) => {
  switch (rank) {
    case 'E5':
      return '5';
    case 'E6':
      return '7';
    default:
      return '';
  }
};
